<template>
  <p
    :id="id"
    class="roomie-tag"
    :class="`roomie-tag--${variant} roomie-tag--${size}`">
    <slot name="icon" />
    <slot name="content" />
    <span v-if="!$slots.content">{{ label }}</span>
  </p>
</template>

<script>

import { VARIANT, SIZE } from './utils'
export { SIZE, VARIANT } from './utils'

export default {
  name: 'RoomieTag',
  props: {
    id: {
      type: String,
      required: true
    },
    variant: {
      type: String,
      default: 'neutral',
      required: false,
      validator: (value) => Object.keys(VARIANT).includes(value)
    },
    label: {
      type: String,
      default: 'Neutral',
      required: false
    },
    size: {
      type: String,
      default: SIZE.sm,
      validator: (value) => Object.keys(SIZE).includes(value)
    },
  },
}
</script>

<style
  lang="scss"
  src="./_index.scss">
</style>
